import { compact, uniq } from "lodash";
import { GetNewsSelectionFilesManagerVariables } from "src/api/generated/GetNewsSelectionFilesManager";
import { ISelectableRealestate } from "src/stores/RealestateStore";

// The recipients of a news, as Micro.News expects them in "role".
export enum NewsRecipientRole {
    COOWNER = 32,
    TENANT = 33
}

export const getNewsRecipientRole = (isCondominium: boolean): NewsRecipientRole =>
    isCondominium ? NewsRecipientRole.COOWNER : NewsRecipientRole.TENANT;

// The portal only combines realestates of one kind (the selection offers only that kind), the ERP sends one
// realestate per news. Older news can still mix both kinds, then STWEG wins and the news is for coowners.
// Realestates without access are null. Without any visible realestate the kind is unknown (undefined): neither
// the portal nor Micro.News may read the realestates of a colleague. Each caller decides what that means.
export const isCondominiumNews = (realestates: ({ condominium: boolean } | null)[]): boolean | undefined => {
    const visibleRealestates = compact(realestates);
    if (visibleRealestates.length === 0) return undefined;

    return visibleRealestates.some((realestate) => realestate.condominium);
};

// Files of the selected realestates. Micro.News detaches the files of removed realestates by the same rule
// (NewsRealestateFiles.FilterFor), keep both in step.
// - realestateandconsolidationids is matched with the realestateid of a file: the realestates themselves and, for
//   IT2, their consolidations (Mandanten), whose files belong to them as well.
// - realestateids is matched with the consolidationid of a file: a selected realestate that is a consolidation
//   also owns the files of its realestates.
export const getNewsSelectionFilesVariables = (
    realestates: ISelectableRealestate[],
    isIT2: boolean
): GetNewsSelectionFilesManagerVariables => {
    const realestateIds = realestates.map((realestate) => realestate.id);
    const consolidationIds = isIT2
        ? realestates.flatMap((realestate) => (realestate.consolidationid ? [realestate.consolidationid] : []))
        : [];

    return {
        realestateandconsolidationids: uniq([...realestateIds, ...consolidationIds]),
        realestateids: realestateIds
    };
};
